<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
/* 分页组件 靠右 */
.page-box {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue